var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.from = 0;
        _this.style = '';
        _this.data = '';
        _this.formData = {
            agent_warehouse_id: '',
            agent_warehouse_name: '',
            organ_name: '',
            appkey: '',
            appsecret: '',
            edi_api_url: '',
            contact: '',
            contact_phone: '',
        };
        return _this;
    }
    EditDialog.prototype.created = function () {
        if (this.from == 0)
            this.style = { height: '250px' };
        else if (this.from == 1)
            this.style = { height: '330px' };
        this.formData = {
            agent_warehouse_id: this.data.agent_warehouse_id,
            agent_warehouse_name: this.data.agent_warehouse_name,
            organ_name: this.data.organ_name,
            appkey: this.data.appkey,
            appsecret: this.data.appsecret,
            edi_api_url: this.data.edi_api_url,
            contact: this.data.contact,
            contact_phone: this.data.contact_phone
        };
    };
    EditDialog.prototype.mounted = function () {
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog.prototype.confirm = function () {
        this.$closeDialog();
        this.$emit('editDialog:ok', this.formData);
    };
    EditDialog = __decorate([
        Component
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
